import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const HomeRedirect = () => {
  const auth = useSelector(state => state.auth);
  if (auth.isFullyAuthenticated) return <Navigate to='/home' />;
  else return <Navigate to='/auth/welcome' />;
}

export default HomeRedirect;